import React from 'react';
import classNameBind from 'classnames/bind';
import ActionList from '../../../ActionList';
import Button from '../../../Button';
import Popover from '../../../Popover';
import Tooltip from '../../../Tooltip';
import styles from './AddSection.module.css';

const bindClasses = classNameBind.bind(styles);

const AddSection = ({ mainButton, folderButton, addPopover }) => {
  const btn = (type) => {
    const buttonCfg = type === 'main' ? mainButton : folderButton;

    return (
      <Tooltip content={buttonCfg.tooltip}>
        <Button
          onClick={buttonCfg.onClick}
          text={buttonCfg.text}
          disabled={buttonCfg.disabled}
          appearance={type === 'main' ? 'constructive' : 'default'}
          fullWidth
          icon="plus"
          dataId={buttonCfg.dataId}
        />
      </Tooltip>
    );
  };

  return (
    <div
      className={bindClasses('wrapper')}
      data-ppuc-id="Sidebar.AddSection"
    >
      {
        addPopover
          ? (
            <Popover
              position="top"
              activatorElement={btn('main')}
              subdued={false}
              hoverTrigger={false}
              noPadding
              speechBubble
            >
              {close => (
                <Popover.Section padding="narrow">
                  <ActionList
                    dataId="Sidebar.Folder.Add"
                    groups={addPopover.groups}
                    onItemSelected={(event) => {
                      addPopover.onItemSelected(event);
                      close();
                    }}
                  />
                </Popover.Section>
              )}
            </Popover>
          )
          : btn('main')
      }
      {folderButton ? btn('folder') : null}
    </div>
  );
};

export default AddSection;
